import { Redirect } from "wouter";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Button, Loader } from "@threadws/jute";

export function SignInPage() {
  const { isLoading, isAuthenticated, login } = useKindeAuth();
  if (isLoading) return <Loader />;
  if (isAuthenticated) return <Redirect to="/" replace />;

  return (
    <>
      <span className="font-babyblue text-pixel-2 font-medium tracking-normal">Sage</span>
      <Button variant="primary" onClick={() => login()}>
        Sign in
      </Button>
    </>
  );
}
